import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWindowSize } from "usehooks-ts";
import { useTranslation } from "react-i18next";
import { images } from "../../constants";
import sidebarNav from "../../config/sidebarNav";
import SidebarContext from "../../store/sidebarContext";
import { useLogout } from "../../hooks/useAuth";
import { Icon } from "@iconify/react";
import classes from "./Sidebar.module.scss";
import { safeTranslate } from "../../utils/translation";

function Sidebar() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { width } = useWindowSize();
  const location = useLocation();
  const sidebarCtx = useContext(SidebarContext);
  const { logout, isLoading } = useLogout();
  const { t } = useTranslation();

  function openSidebarHandler() {
    //for width>768(tablet size) if sidebar was open in width<768 was opened too.
    //just in case of tablet size and smaller then, sidebar__open can added.
    if (width <= 768) document.body.classList.toggle("sidebar__open");
  }

  function logoutHandler() {
    openSidebarHandler();
    logout();
  }

useEffect(() => {
  const pathname = location.pathname;
  // Enhanced: allow nav config to provide a custom match function or regex
  const activeItem = sidebarNav.findIndex((item) => {
    if (typeof item.match === 'function') {
      return item.match(pathname);
    }
    if (item.match instanceof RegExp) {
      return item.match.test(pathname);
    }
    // fallback to old logic
    return pathname === item.link || pathname.startsWith(item.link + "/");
  });
  setActiveIndex(activeItem === -1 ? 0 : activeItem);
}, [location]);

  return (
    <div
      className={`${classes.sidebar} ${
        !sidebarCtx.isOpen && classes.sidebar_close
      }`}
    >
      <div className={classes.sidebar__logo}>
        <img src={images.logo} alt="gotik" />
      </div>
      <div className={classes.sidebar__menu}>
        {sidebarNav.map((nav, index) => (
          <Link
            to={nav.link}
            key={`nav-${index}`}
            className={`${classes.sidebar__menu__item} ${
              activeIndex === index && classes.active
            }`}
            onClick={openSidebarHandler}
          >
            <div className={classes.sidebar__menu__item__icon}>
              <Icon icon={nav.icon} />
            </div>
            <div className={classes.sidebar__menu__item__txt}>
              {safeTranslate(t, nav.section, nav.text)}
            </div>
          </Link>
        ))}
      </div>

      <div className={[classes.sidebar__menu, classes.logout].join("")}>
        <Link
          to="/login"
          className={classes.sidebar__menu__item}
          onClick={logoutHandler}
        >
          <div className={classes.sidebar__menu__item__icon}>
            <Icon icon="tabler:logout" />
          </div>
          <div className={classes.sidebar__menu__item__txt}>{safeTranslate(t, "logout")}</div>
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
